const hero = document.querySelector('.page-hero');
const heroTitle = document.querySelector('.page-hero__title');
const heroSubtitle = document.querySelector('.page-hero__subtitle');

window.onscroll = function() {
  if(!hero) {
    return;
  }

  var scrolled = window.pageYOffset || document.documentElement.scrollTop;
  var opacity = 1 - scrolled / hero.clientHeight;
  var bottom = scrolled / 5;

  if(heroTitle) {
    heroTitle.style.opacity = opacity;
  }

  if(heroSubtitle) {
    heroSubtitle.style.opacity = opacity;
  }

  hero.style.transform = 'translateY(' + bottom + 'px' + ')';

};



// WEBPACK FOOTER //
// ./assets/js/page-hero.js